import ActionButton from '@components/ActionButton';
import { CSSObject, Theme, styled } from '@mui/material';

// TODO add color to library
const inactiveSwitcherBg = '#F9F9F9';
const switcherHoverBg = '#EBF6F7';

export const sxStyles = {
  switcherWrap: {
    display: 'flex',
    maxWidth: '80px',
    maxHeight: '40px',
  },
};

function StyledSwitchButton(isActive: boolean, theme: Theme): CSSObject {
  return {
    padding: 0,
    minWidth: '40px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: isActive ? 'transparent' : theme.palette.grey['300'],
    backgroundColor: isActive ? theme.palette.primary.main : inactiveSwitcherBg,

    svg: {
      color: theme.palette.grey['300'],
      fill: isActive ? theme.palette.common.white : theme.palette.primary.main,
    },

    '&:hover': {
      borderColor: theme.palette.primary.dark,
      backgroundColor: isActive ? theme.palette.primary.main : switcherHoverBg,
    },
  };
}

export const StyledSwitchReducedButton = styled(ActionButton, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>(({ isActive, theme }) => ({
  ...StyledSwitchButton(isActive, theme),

  minHeight: '40px',
  borderRight: 'none',
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
}));

export const StyledSwitchLinearButton = styled(ActionButton, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>(({ isActive, theme }) => ({
  ...StyledSwitchButton(isActive, theme),

  borderLeft: 'none',
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
}));
